var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 65,
    viewBox: "0 0 107 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3733_3433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.819 44.7196C100.172 46.3686 98.2152 47.6786 96.0606 48.5709C93.9059 49.4632 91.5973 49.9231 89.2668 49.9231C86.9363 49.9231 84.6259 49.4632 82.473 48.5709C80.3184 47.6786 78.3616 46.3686 76.7145 44.7196L64.1621 32.1563L76.7145 19.5929C80.0472 16.2657 84.5636 14.3987 89.2741 14.4023C93.9829 14.406 98.4992 16.2785 101.826 19.6094C105.156 22.9404 107.024 27.4567 107.023 32.1654C107.023 36.8742 105.15 41.3905 101.819 44.7196Z",
    fill: "url(#paint0_linear_3733_3433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0749 0C24.1122 0 16.4335 2.96449 10.5338 8.31265C4.63415 13.6608 0.934958 21.0116 0.154445 28.9358C-0.626069 36.86 1.57073 44.7916 6.31427 51.1878C11.0578 57.584 18.011 61.9867 25.8216 63.5386C33.6322 65.0923 41.7415 63.6851 48.5719 59.592C55.4024 55.4989 60.4665 49.0111 62.7788 41.391C65.091 33.771 64.4864 25.5646 61.0821 18.3659C57.6779 11.1672 51.7178 5.49108 44.3616 2.44414C40.4663 0.829983 36.2908 0 32.0749 0ZM49.9479 46.0247C47.207 48.7619 43.7166 50.6235 39.9167 51.3783C36.1167 52.1314 32.1793 51.7429 28.6029 50.2588C25.0246 48.7748 21.9667 46.2647 19.8157 43.0437C17.6647 39.8227 16.5159 36.0374 16.5159 32.1641C16.5159 28.2909 17.6647 24.5056 19.8157 21.2846C21.9667 18.0636 25.0246 15.5535 28.6029 14.0694C32.1812 12.5853 36.1185 12.1969 39.9167 12.9499C43.7166 13.703 47.207 15.5663 49.9479 18.3036L63.7645 32.1311L49.9479 46.0283V46.0247Z",
    fill: "url(#paint1_linear_3733_3433)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3733_3433",
    x1: -17.5555,
    y1: 23.1071,
    x2: 140.345,
    y2: 36.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#452F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED2D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3D97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3733_3433",
    x1: -13.041,
    y1: 28.2524,
    x2: 135.414,
    y2: 40.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#452F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED2D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3D97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3733_3433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 64.1267,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.c724463b2515a4624b57c50aa75198c2.svg";
export { ForwardRef as ReactComponent };